import { render, staticRenderFns } from "./PaymentAttributeDetail.vue?vue&type=template&id=18cbd390"
import script from "../../controllers/payment_attribute/payment-attribute-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_attribute/payment-attribute-detail.js?vue&type=script&lang=js&external"
import style0 from "./PaymentAttributeDetail.vue?vue&type=style&index=0&id=18cbd390&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports